<template>
  <v-card>
    <v-form>
      <v-card-title>
        {{ $t('payment.application.performActionTitle') }}
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="6">
              <vf-date-input
                v-model="actualDate"
                :label="$t('payment.application.actualDate')"
                outlined
                dense
                @change="$v.form.originalDate.$touch()"
                :min="step.minActualDate"
                :disabled="!step.isActive"
              />
            </v-col>
            <v-col
              v-for="(field, index) in step.fieldsToFill"
              :key="index"
              cols="6"
            >
              <v-text-field
                v-model="form[field.key]"
                :label="field.label"
                outlined
                dense
              />
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="comment"
                :label="$t('payment.application.comment')"
                outlined
                dense
                rows="2"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-container>
          <v-row align="baseline">
            <v-spacer />
            <v-col cols="3">
              <v-btn
                rounded
                dense
                block
                small
                outlined
                color="primary"
                @click="handleCancelForm"
              >
                {{ $t('common.cancel') }}
              </v-btn>
            </v-col>
            <v-col cols="3">
              <SubmitButton
                @click="handleSubmitForm"
                block
                small
                :disabled="disableSave"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
export default {
  name: 'PerformActionForm',
  props: {
    step: Object,
    application: Object
  },
  data () {
    return {
      actualDateMenu: false,
      actualDate: null,
      comment: '',
      form: this.step.fieldsToFill.reduce(
        (acc, curr) => ({ ...acc, [curr.key]: this.application[curr.key] }),
        { }
      )
    }
  },
  computed: {
    disableSave () {
      return !this.actualDate || !Object.values(this.form).every((i) => i)
    }
  },
  methods: {
    async handleSubmitForm () {
      this.$emit('performaction', {
        applicationField: this.form,
        actualDate: this.actualDate,
        comment: this.comment
      })
      this.cleanAndCloseForm()
    },
    handleCancelForm () {
      this.cleanAndCloseForm()
    },
    cleanAndCloseForm () {
      this.form = this.step.fieldsToFill.reduce(
        (acc, curr) => ({ ...acc, [curr.key]: this.application[curr.key] }),
        {}
      )
      this.comment = ''
      this.actualDate = null
      this.$eventBus.$emit('CLOSE_MODAL')
    }
  },
  watch: {
    application (v) {
      this.form = this.step.fieldsToFill.reduce(
        (acc, curr) => ({ ...acc, [curr.key]: v[curr.key] }),
        {}
      )
    }
  }
}
</script>
